"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var clsx_1 = require("clsx");
var react_1 = require("react");
var Price_1 = require("../price/Price");
var financeQuotePricesStyles_1 = require("./financeQuotePricesStyles");
var useSummaryContext_1 = require("../../../react/useSummaryContext");
var PriceDisplayType_1 = require("../../../../../../common/enum/PriceDisplayType");
var FinanceQuotePricesSingleCurrency = function (_a) {
    var labelBefore = _a.labelBefore, labelAfter = _a.labelAfter, primaryPrice = _a.primaryPrice, dataTest = _a.dataTest, variant = _a.variant, className = _a.className;
    var _b;
    var style = financeQuotePricesStyles_1.default();
    var finance = useSummaryContext_1.default().priceDisplay.finance;
    return (<core_1.Box className={style.financeQuoteMultiWrapper} component="span" data-test="summary:container:finance_quote_prices">
      {labelBefore}
      <core_1.Box className={style.prices} component="span">
        <Price_1.default price={primaryPrice.value} priceDisplayType={PriceDisplayType_1.PriceDisplayType.FINANCE} currency={primaryPrice.currency} decimals={(_b = finance) === null || _b === void 0 ? void 0 : _b.decimalScale} variant={variant} className={clsx_1.default([style.priceElement, className])} dataTest={dataTest}/>
      </core_1.Box>
      {labelAfter}
    </core_1.Box>);
};
exports.default = FinanceQuotePricesSingleCurrency;
